/** SF Environment Challenge stakeholder contacts (Trello #77 / #78). */
export const CCSF_CONTACT_EMAILS =
  'Jax.Puliati@sfgov.org, Sierra.Barsten@sfgov.org, or Brian.Reyes@sfgov.org';

export const CCSF_CONTACT_MAILTO =
  'mailto:Jax.Puliati@sfgov.org,Sierra.Barsten@sfgov.org,Brian.Reyes@sfgov.org';

export const CCSF_CONTACT_FAQ_ANSWER =
  `Email ${CCSF_CONTACT_EMAILS} at SF Environment for help.`;

/** Pilot participation scope (Trello #87 — Key details / Who can join). */
export const CCSF_WHO_CAN_JOIN_DETAILS =
  'This challenge is a pilot between City staff at Airport Commission, Environment, Planning, Public Works, and Rec and Park. Still, staff in other agencies are welcome to participate this year but won\'t be eligible for awards and prizes. We look forward to expanding agencywide during Fall of 2027.';

/** Bullet under Other in Participating Departments list (Trello #90). Dropdown label stays "Other". */
export const CCSF_OTHER_DEPARTMENT_BULLET =
  'For staff in non-participating departments are welcome to join';
